import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { boldFont, textSize, color } from '@portal/kit/pkg/styles'

import { withRanIcon, ranIcon, withDesktopRanIcon, desktopRanIcon } from 'styles/helpers'

const { boxMobileMargin, boxMargin } = config.dimensions

const ranRoomCardStyles = createUseStyles(theme => ({
  ranRoom: {
    margin: `0 -${boxMobileMargin}px ${boxMobileMargin}px -${boxMobileMargin}px`,
    padding: `0 ${boxMobileMargin}px ${boxMobileMargin}px ${boxMobileMargin}px`,
    borderBottom: `1px solid ${config.colors.divider}`,

    '&:last-child': {
      border: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    }
  },
  ranRoomTitle: {
    position: 'relative',
    ...withRanIcon(),
    marginBottom: boxMobileMargin / 2,

    '& strong': {
      ...boldFont()
    }
  },
  ranRoomFooter: {
    ...textSize(12, 14),
    paddingTop: boxMobileMargin / 2,
    paddingLeft: 1,
    ...color('textSecondary')
  },
  ranRoomIcon: {
    ...ranIcon(theme),
    top: '50%',
    transform: 'translateY(-50%)',
  },
  [config.mediaQueries.tabletPortrait]: {
    ranRoom: {
      margin: `0 -${boxMargin}px ${boxMobileMargin}px -${boxMargin}px`,
      padding: `0 ${boxMargin}px ${boxMobileMargin}px ${boxMargin}px`,

      '&:last-child': {
        marginBottom: 0,
        paddingBottom: 0,
      }
    },
    ranRoomIcon: {
      ...desktopRanIcon(),
    },
    ranRoomTitle: {
      ...withDesktopRanIcon(),
    },
  }
}))

export default ranRoomCardStyles
